import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function fmt(v) {
  if (v == null) return "";
  return String(v);
}

function pad(n) {
  const x = String(n || "");
  return x.length === 1 ? `0${x}` : x;
}

function formatDate(d) {
  if (!d) return "";
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return fmt(d);
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
}

export default function generateManifestListPdf(rows = [], opts = {}) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();

  doc.setFontSize(16);
  doc.text("Air Cargo Manifest", pageW / 2, 40, { align: "center" });
  doc.setFontSize(10);
  doc.text("I.C.A.O. Annex 9, Appendix 3", pageW / 2, 56, { align: "center" });

  const meta = [];
  if (opts?.from) meta.push(`From: ${formatDate(opts.from)}`);
  if (opts?.to) meta.push(`To: ${formatDate(opts.to)}`);
  if (meta.length) doc.text(meta.join("  |  "), pageW / 2, 74, { align: "center" });

  const body = (Array.isArray(rows) ? rows : []).map((r) => [
    fmt(r.id),
    fmt(r.flight_no),
    formatDate(r.date_of_arrival),
    fmt(r.place_of_departure_code),
    fmt(r.place_of_destination_code),
    fmt(r.total_bols),
    fmt(r.total_packages),
    fmt(r.total_gross_mass),
    r.is_delivered ? "YES" : "NO",
  ]);

autoTable(doc, {
  startY: 95,
  theme: "grid",
  head: [[
    "Manifest No",
    "Flight No",
    "Arrival",
    "Loading",
    "Unloading",
    "AWBs",
    "Pieces",
    "Weight",
    "Delivered",
  ]],
  body,
  styles: { fontSize: 9, cellPadding: 3 },

  // ✅ لون هيدر أزرق (سيأتي شرحه بالجزء الثاني)
  headStyles: {
    fontStyle: "bold",
    fillColor: [30, 136, 229], // أزرق
    textColor: 255,
  },

  // ✅ تلوين الصفوف المسلّمة
  didParseCell: function (data) {
    // عمود Delivered هو آخر عمود (index = 8)
    if (data.section === "body" && data.column.index === 8) {
      if (String(data.cell.raw).toUpperCase() === "YES") {
        // لو Delivered = YES
        data.cell.styles.fillColor = [76, 175, 80]; // أخضر
        data.cell.styles.textColor = 255;
        data.cell.styles.fontStyle = "bold";
      }
    }
  },
});


  doc.save(`manifest_list_${formatDate(opts?.from) || ""}_${formatDate(opts?.to) || ""}.pdf`);
}
